import React, { useLayoutEffect, useRef } from 'react';

import executePolyfill from '../utils/picturefill';

const Picture = ({ children }) => {
  const element = useRef();

  useLayoutEffect(() => {
    executePolyfill([element.current]);
  }, []);

  return <picture ref={element}>{children}</picture>;
};

export default Picture;
